import styled from 'styled-components';
import { Grid, Chip } from '@material-ui/core';
import { IntlShape, injectIntl } from 'react-intl';
import { IconButton, Collapse } from '@material-ui/core';
import { handleCollapseRow } from 'containers/LawyerDocumentsPage/utils';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { CollapseContainer } from 'containers/LawyerFeeNote/styled-components';
import TimeAgo from 'timeago-react';
import * as timeago from 'timeago.js';
import fr from 'timeago.js/lib/lang/fr';
import { INotification } from 'containers/AppContainer/typings';
import AlertNotification from 'containers/AppContainer/Notifications/AlertNotification';
import currentIntervenantStorage from 'containers/services/security/current-intervenant-storage';
import { isAlertNotificationForLawyer } from 'containers/AppContainer/utils';

export const Container = styled.div`
  text-align: left;
  border-top: 1px solid #f5f5f5;
  border-bottom: 1px solid #f5f5f5;
  padding: 24px;
  font-weight: 500;
  .notification-container {
    width: 100%;
    padding: 10px;
    display: flex;
    flex-direction: column;
    margin-top: 3px;
  }
`;
const chipBody = {
  backgroundColor: 'rgb(237, 238, 238)',
  fontSize: '14px',
  paddingLeft: '5px',
};
export const StyledGrid = styled(Grid)`
  margin-top: 5px;
  background-color: #f7f9fc;
  border-radius: 5px;
  padding: 20px;
  font-weight: 300;
`;
export const RedStyledGrid = styled(Grid)`
  margin-top: 5px;
  background-color: #fcefec;
  border-radius: 5px;
  padding: 20px;
  font-weight: 300;
  color: #ff3400;
`;
export const StyledBinGrid = styled(Grid)`
  margin-top: 5px;
`;

export interface BinProps {
  intl: IntlShape;
  title: string;
  isManager?: boolean;
  count?: number;
  index: number;
  currentClaimId: number | null;
  setCurrentClaimId: Function;
  setCurrentNotificationId: Function;
  expandRow: any;
  setExpandRow: any;
  lawyerNotifications?: INotification[];
  setIsNotificationDialogOpen?: Function;
  id: number;
  procedureId?: number;
}

const Bin = (props: BinProps) => {
  const notificationDialogHandler = (el: any) => () => {
    props.setIsNotificationDialogOpen &&
      props.setIsNotificationDialogOpen(true);
    props.setCurrentClaimId(el.claimId);
    props.setCurrentNotificationId(el.id);
  };

  timeago.register('fr', fr);

  let { lawyerNotifications, procedureId } = props;
  if (procedureId) {
    lawyerNotifications = lawyerNotifications?.filter(
      notif => String(notif.judiciaryProcessBinId) === String(procedureId),
    );
  }
  return (
    <Container>
      <Grid container direction="row">
        {!props.isManager && (
          <Grid item xs={3}>
            <Chip style={chipBody} label={props.count} />
          </Grid>
        )}
        <StyledBinGrid item xs={8}>
          {props.title}
        </StyledBinGrid>
        <StyledBinGrid item xs={1}>
          <IconButton
            aria-label="expand-row"
            size="small"
            onClick={handleCollapseRow(
              props.index,
              props.expandRow,
              props.setExpandRow,
            )}
          >
            {props.expandRow && props.expandRow[props.index]
              ? !props.isManager && <KeyboardArrowUpIcon />
              : !props.isManager && <KeyboardArrowDownIcon />}
          </IconButton>
        </StyledBinGrid>
      </Grid>
      <Collapse
        in={props.expandRow && props.expandRow[props.index]}
        timeout="auto"
        unmountOnExit
      >
        <CollapseContainer className="notification-container">
          {lawyerNotifications
            ?.filter(
              el =>
                el.binLawyerId === props.id &&
                el.readBy === null &&
                el.lawyerCode === currentIntervenantStorage.get()?.sagis_code,
            )
            .sort(
              (a, b) =>
                new Date(b.created_at).valueOf() -
                new Date(a.created_at).valueOf(),
            )
            .map(el => (
              <div style={{ cursor: 'pointer' }}>
                <Grid
                  container
                  direction="row"
                  onClick={notificationDialogHandler(el)}
                >
                  {isAlertNotificationForLawyer(el.title) ? (
                    <AlertNotification
                      title={el.title as any}
                      created_at={el.created_at}
                    />
                  ) : (
                    <StyledGrid item xs={8}>
                      {el.title}
                    </StyledGrid>
                  )}
                  {isAlertNotificationForLawyer(el.title) ? (
                    <></>
                  ) : (
                    <StyledGrid item xs={4}>
                      <TimeAgo datetime={el.created_at} locale="fr" />
                    </StyledGrid>
                  )}
                </Grid>
              </div>
            ))}
        </CollapseContainer>
      </Collapse>
    </Container>
  );
};

export default injectIntl(Bin);
